import React from 'react';

export interface OccupancyMeterProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  used: number;
  maximum: number;
  label: string;
  hotThreshold?: number;
  showValues?: boolean;
}

const getOccupancyPercentage = (used: number, maximum: number): number => {
  if (!Number.isFinite(used) || !Number.isFinite(maximum) || maximum <= 0) {
    return 0;
  }

  return Math.min(100, Math.max(0, (used / maximum) * 100));
};

export const OccupancyMeter: React.FC<OccupancyMeterProps> = ({
  used,
  maximum,
  label,
  hotThreshold = 90,
  showValues = true,
  className = '',
  ...props
}) => {
  const percentage = getOccupancyPercentage(used, maximum);
  const hot = percentage >= hotThreshold;

  return (
    <div
      {...props}
      className={`admin-occupancy-meter ${className}`.trim()}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={Math.max(0, maximum)}
      aria-valuenow={Math.min(Math.max(0, used), Math.max(0, maximum))}
      aria-valuetext={`${used} of ${maximum}`}
      data-hot={String(hot)}
    >
      {showValues && <span className="admin-occupancy-meter__label">{used} / {maximum}</span>}
      <span className="admin-occupancy-meter__track" aria-hidden="true">
        <span
          className={`admin-occupancy-meter__fill${hot ? ' admin-occupancy-meter__fill--hot' : ''}`}
          style={{ width: `${percentage}%` }}
        />
      </span>
    </div>
  );
};
